import VeeValidate, { Validator } from 'vee-validate';
import French from 'vee-validate/dist/locale/fr';
import * as veeRules from 'vee-validate/dist/rules.esm';
import Vue from 'vue';

const messageRequired = 'Ce champ est obligatoire';
// const messageDecimal = 'Ce champ doit avoir une valeur de 0 ou plus.';
const dictionary = {
  fr: {
    custom: {
      nom: {
        required: messageRequired,
      },
      prenom: {
        required: messageRequired,
      },
      adresseRue: {
        required: messageRequired,
      },
      adresseLocalite: {
        required: messageRequired,
      },
      typeResident: {
        required: messageRequired,
      },
      isActivite100PourCent: {
        required: messageRequired,
      },
      isRevenuUnSeulEmployeur: {
        required: messageRequired,
      },
      etatCivil: {
        required: messageRequired,
      },
      hasEnfants: {
        required: messageRequired,
      },
      isMarie: {
        required: messageRequired,
      },
      isConjointFonctionnaireInt: {
        required: messageRequired,
      },
      typeFonctInt: {
        required: messageRequired,
      },
      sourceRevenu: {
        required: messageRequired,
      },
      isUnionLibre: {
        required: messageRequired,
      },
      isGardeAlternee: {
        required: messageRequired,
      },
      hasConjointRevenu: {
        required: messageRequired,
      },
      periodeFiscale: {
        required: messageRequired,
      },
      revenuContribuable: {
        required: messageRequired,
        decimal: messageRequired,
      },
      revenuConjoint: {
        required: messageRequired,
        decimal: messageRequired,
      },
      revenuContribuableEUR: {
        required: messageRequired,
        decimal: messageRequired,
      },
      revenuConjointEUR: {
        required: messageRequired,
        decimal: messageRequired,
      },
      bareme: {
        required: messageRequired,
      },
      nbEnfants: {
        required: messageRequired,
      },
      anneesNaissanceEnfants0: {
        required: messageRequired,
        decimal: messageRequired,
      },
      anneesNaissanceEnfants1: {
        required: messageRequired,
        decimal: messageRequired,
      },
      anneesNaissanceEnfants2: {
        required: messageRequired,
        decimal: messageRequired,
      },
      anneesNaissanceEnfants3: {
        required: messageRequired,
        decimal: messageRequired,
      },
      anneesNaissanceEnfants4: {
        required: messageRequired,
        decimal: messageRequired,
      },
    },

  },
};

Validator.localize('fr', French); // changes the locale
Object.keys(veeRules).forEach((k) => Validator.extend(k, veeRules[k]));
Validator.localize('fr', dictionary);
// Vue.use(VeeValidate, {
//   // events: ''
//   // inject: false
//   locale: 'fr',
//   // validity: true
// });
Vue.use(VeeValidate, { dictionary, locale: 'fr', useConstraintAttrs: false });
